import { useQuery } from "@tanstack/react-query";
import apiClient from "./axios";

const DEFAULT_PATH = "app/assets/images";

export function assetQueryKey(key: string, path: string = DEFAULT_PATH) {
  const fullKey = key ? `${path}/${key}` : "";
  return ["asset-url", fullKey] as const;
}

export function useSignedUrlQuery(
  key: string,
  _bucket?: string,
  path: string = DEFAULT_PATH
) {
  const queryKey = assetQueryKey(key, path);

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await apiClient.get<{ url: string }>(`assets/files/${queryKey[1]}`);
      return response.data.url;
    },
    enabled: !!queryKey[1],
    staleTime: 4 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchInterval: 4 * 60 * 1000,
  });
}

export function useSignedUrl(
  key: string,
  _bucket?: string,
  path: string = DEFAULT_PATH
): string {
  const { data } = useSignedUrlQuery(key, _bucket, path);
  return data ?? "";
}
